import { render, staticRenderFns } from "./CrossPlatformDevelopment.vue?vue&type=template&id=95616f8a&"
import script from "./CrossPlatformDevelopment.vue?vue&type=script&lang=js&"
export * from "./CrossPlatformDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports